const SHIPPOP = "shippop";
const MASTER = "master";
const SUPERADMIN = "superadmin";
const ADMIN = "admin";
const MEMBER = "member";
const PAYMENT_TYPE_PREPAID = "PREPAID";
let userDetails = null;

const userLogin = {
  get() {
    const user = this.loadCurrentUser();
    if (user == false) {
      return null;
    }

    return {
      details             : userDetails,
      isShippop           : this.isShippop(),
      isMaster            : this.isMaster(),
      isSuperadmin        : this.isSuperadmin(),
      isAdmin             : this.isAdmin(),
      isMember            : this.isMember(),
      isUnderByShippop    : this.isUnderByShippop(),
      isPaymentTypePrepaid: this.isPaymentTypePrepaid(),
    };
  },
  loadCurrentUser() {
    return true
  },
  isShippop() {
    return true
  },
  isMaster() {
    return true
  },
  isSuperadmin() {
    return true
  },
  isAdmin() {
    return true
  },
  isMember() {
    return true
  },
  isUnderByShippop() {
    return true
  },
  isPaymentTypePrepaid() {
    return true
  },
};

export default userLogin;
